import API from 'services/api';

export const getPaymentCodeFromRoot = () => API.get('api/root/payment-models/all');
